/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { Select as AntdSelect } from "antd";
import { SelectProps as AntdSelectProps } from "antd";
import { InputStyle } from "src/constants/theme.constant";
import { ArrowDownIcon } from '../icons.component';
import { AppMessages } from "src/constants/messages.constant";

type SelectProps = AntdSelectProps & {
  className?: string,
  style?: InputStyle,
  showSearch?: boolean,
  searcheableLabel?: string,
};

const Select = ({
  className,
  style = InputStyle.Primary,
  showSearch = false,
  searcheableLabel = 'label',
  ...props
} : SelectProps) => {
  return (
    <>
      <AntdSelect
        {...props}
        className={`select-input select-${style} ${className ?? ''}`}
        suffixIcon={
          <>
            <ArrowDownIcon />
          </>
        }
        showSearch ={showSearch}
        filterOption={(input, option:any) =>
          (option?.[searcheableLabel] ?? '').toLowerCase().includes(input.toLowerCase())
        }
        notFoundContent={AppMessages.SEARCH_NOT_FOUNT}
      />
    </>
  );
};

export default Select;
